import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { Comunicacion } from '../models/Comunicacion';
import { API_URI } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ComunicacionService {
  private readonly API_URI: string = API_URI + 'app';

  constructor(private http: HttpClient) { }

  getComunicaciones(): Observable<Comunicacion[]>{
    return this.http.get<Comunicacion[]>(`${this.API_URI}/comunicaciones/buscar`);
  }

  getComunicacion(id: number): Observable<Comunicacion | null>{
    return this.http
      .get<Comunicacion>(`${this.API_URI}/comunicaciones/xId/${id}`)
      .pipe(catchError(() => of(null)));
  }

  enviarComunicacion(formData: FormData): Observable<any>{
    return this.http.post<any>(`${this.API_URI}/comunicaciones`, formData);
  }
}
